import { ArrowCircleUp } from "@mui/icons-material";
import { Box, ButtonBase, Fade, IconButton, Slide, useMediaQuery, useScrollTrigger } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';
import { LayoutState, MediaQueryShallow } from "../Layout";
import MainNavigationMobile from "./MainNavigationMobile";

export default function LogoDesktop(params: {layoutState: LayoutState}) {
   // Init layout parameters
   const layoutState = params.layoutState;
   layoutState.isShallow = useMediaQuery(MediaQueryShallow);

   // Setup scroll triggers
   const isScrolled = useScrollTrigger({ disableHysteresis: false, threshold: 100 });

   return (
      <Box>
         <Slide appear={false} direction="down" in={!isScrolled}>
            <Box>
               {layoutState.isShallow &&
                  <MainNavigationMobile></MainNavigationMobile>
               }
               <Box id='logo-blank' sx={{ bgcolor: "kr.main", position: "fixed", left: 0, top: 0, height: layoutState.LogoHeight(), width: "calc(100vW)", zIndex: 1 }} />
               <Box id='logo' sx={{ bgcolor: "kr.main", position: "fixed", top: layoutState.LogoTop(), right: layoutState.LogoRight(), zIndex: 1 }} >
                  <ButtonBase component={RouterLink} to="/">
                     <img src="/img/logo.png" style={{ height: layoutState.LogoHeightImg() }} />
                  </ButtonBase>
               </Box>
            </Box>
         </Slide>
         <Fade in={isScrolled}>
            <Box
               id='scrollup'
               onClick={() => window.scrollTo(0, 0)}
               role="presentation"
               sx={{ position: 'fixed', right: 40, bottom: 40, zIndex: 10 }}
            >
               <IconButton><ArrowCircleUp fontSize="large"></ArrowCircleUp></IconButton>
            </Box>
         </Fade>
      </Box>
   );
}